import { useTranslation } from 'react-i18next';

import websiteDisabled from '@/assets/icons/arrow-left-2.svg';

import { BackIcon, HeaderTitle } from '../styles/enhance-modal.styles';

export const EnhanceHeader = ({
  onBack,
  showBackButton,
}: {
  onBack: () => void;
  showBackButton: boolean;
}) => {
  const { t } = useTranslation(['projects', 'default']);

  return (
    <HeaderTitle>
      {showBackButton && <BackIcon src={websiteDisabled} onClick={onBack} />}
      {t`enhanceConfigHeader`}
    </HeaderTitle>
  );
};
